module.exports = __webpack_public_path__ + "img/favorite-heart-button.dea686a0.png";